import styled from '@emotion/styled';

import {Message} from "@britishcouncil/react-extro-ui";

export const Form = styled.form`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 4px 0px rgba(84, 86, 90, 0.24);
  padding: 16px;

  & > .form-group {
    margin-bottom: 24px;
  }
`;

export const ButtonContainer = styled.div`
    border-top: 1px solid #c1c1c1;
    padding-top: 24px;
    margin-top: 6px;
    display: flex;
    justify-content: space-between;

    .btn {
        padding-left: 40px;
        padding-right: 40px;
    }
`;

export const StyledMessage = styled(Message)`
    margin-bottom: 20px;
`;

